/** Shared RBAC role identity — used by schemas and UI (keep out of page modules). */

export type Role =
  | 'unify-admin'
  | 'practice-owner'
  | 'practice-admin'
  | 'supervisor'
  | 'provider'
  | 'client';

export const ROLE_LABELS: Record<Role, string> = {
  'unify-admin': 'Unify Admin',
  'practice-owner': 'Practice Owner',
  'practice-admin': 'Practice Admin',
  supervisor: 'Supervisor',
  provider: 'Provider',
  client: 'Client',
};
